import {useParams, useSearchParams} from 'react-router-dom';
import {
  ModuleEnum,
  PermissionOperationEnum,
  UserTypeEnum,
} from 'src/api/ProactApiClient';
import type {PersonnelViewType} from 'src/shared/constants/ViewTypes';
import {PersonnelForm} from 'src/app/personnel/PersonnelForm/PersonnelForm';
import {PersonnelDocumentTitle} from 'src/app/personnel/personnelHelpers';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import type {ViewModeType} from 'src/shared/services/RouterService/IRouteService';
import {PersonnelRouteService} from 'src/shared/services/RouterService/PersonnelRouteService';

export const ViewPersonnelPage = () => {
  const {personnelId, view} = useParams();
  const [searchParams] = useSearchParams();
  useSetDocumentTitle(PersonnelDocumentTitle);

  const fromTabParam = searchParams.get('from');
  const fromTab = fromTabParam === 'all' ? 'all'
    : fromTabParam === 'activity' ? 'activity'
    : 'employee' as const;

  const mode: ViewModeType = 'view';
  const router = new PersonnelRouteService(false, mode, {
    view: view as PersonnelViewType,
    fromTab,
  });

  return (
    <PersonnelForm
      mode={mode}
      userType={UserTypeEnum.Employee}
      id={+personnelId!}
      view={view as PersonnelViewType}
      enableEdit={true}
      router={router}
      fromTab={fromTab}
    />
  );
};

export default ViewPersonnelPage;

// Register the routes with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.PersonnelView(':personnelId', ':view'),
  element: <ViewPersonnelPage />,
  module: ModuleEnum.Personnel,
  operation: PermissionOperationEnum.View,
  isPrivate: true,
});

routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.LegacyPersonnelView(':personnelId', ':view'),
  element: <ViewPersonnelPage />,
  module: ModuleEnum.Personnel,
  operation: PermissionOperationEnum.View,
  isPrivate: true,
});

routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.Legacy2PersonnelView(':personnelId', ':view'),
  element: <ViewPersonnelPage />,
  module: ModuleEnum.Personnel,
  operation: PermissionOperationEnum.View,
  isPrivate: true,
});
